<template>
    <Head :title="$page.props.title ? `${$page.props.title} - BBE` : 'BBE'">
        <meta name="description" :content="$page.props.description || 'Default description'" />

        <slot />
    </Head>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'

export default {
    components: {
        Head,
    },
    methods: {
        pageUrl() {
            return window.location.href
        }
    }
}
</script>
